import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { HrmRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict, CountryDict } from 'types';
import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: RequestListSearchResponse<HrmRequestFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  findLeaveType: (statusNum: number) => CountryDict | undefined
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => ({
    key: requestItem.requestId,
    requestNo: requestItem.requestId,
    country:
      findLeaveType(requestItem.leaveTypeID)?.countryName ||
      EMPTY_FIELD_PLACEHOLDER,
    empNumber: requestItem.empNumber,
    empName: requestItem.empName,
    approverName: requestItem.approverName,
    travelDate: parseDateTime(requestItem.travelDate),
    returnDate: parseDateTime(requestItem.returnDate),
    destination: requestItem.destination || EMPTY_FIELD_PLACEHOLDER,
    currentLocation: requestItem.currentLocation || EMPTY_FIELD_PLACEHOLDER,
    totDays: requestItem.totDays,
    createdBy: requestItem.createdBy,
    createdDate: parseDateTime(requestItem.createdDate),
    status: findStatus(requestItem.reqStatusId)?.codeDesc || '',
  }));
};
